import React from 'react';
var VeltCommentDialogThreadCardFiles = function (props) {
    var children = props.children;
    return (React.createElement("velt-comment-dialog-thread-card-files-wireframe", null, children));
};
export default VeltCommentDialogThreadCardFiles;
